<div class="layout-auto-1-auto">
  <div class="app-section-header">
    <h2>Disposition</h2>
  </div>
  <div class="content">
    <div class="grid grid-auto-1 grid-full-height">
      <div class="width-400 content">
        <exg-data-list #SOlist [rowSource]="summaryData.Schadenorte" selectKey="vorgID"
                       (RowChange)="config.summaryData.rowChange($event)" [allowSingleSelection]="true"
        >
          <ng-template #rowTemplate let-task>
            <div class="list-row-auto-1">
              <div></div>
              <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                <div class="list-metadata" style="margin-left:0">
                  <div>
                    {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
                    {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
                  </div>
                  <div>Auftraggeber: {{task.auAuftraggeberShort}} Schadenart: {{enumSvc.getEnumerationText('Schadenart', task.aue_enmIdent_SchadenArt)}}</div>
                </div>
                <div class="list-metadata ">
                  <div
                    class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                  <div class="typo-right">{{task.marker?.oeName}}</div>
                </div>
                <div class="span-2">
                  <div class="grid-1-auto">
                    <div><strong>{{task.vorgNr}}</strong></div>
                    <div></div>
                  </div>
                </div>
                <div class="span-2 list-secondary-text">
                  <div>{{task.adrStr}} {{task.adrHNum}}</div>
                  <div>{{task.adrPlz}} {{task.adrOrt}}</div>
                  <div> {{task.adrZusatz}}</div>
                </div>
              </div>
            </div>

          </ng-template>
        </exg-data-list>
      </div>
      <div class="content">
        <div
          style="z-index:1;position:absolute; overflow:hidden; border:1px solid; border-radius: 0.5rem; right:10px; top:10px; width:220px; height: 300px">
          <exg-map class="hideprints hidelogo" [latitude]="miniMap.latitude" [longitude]="miniMap.longitude"
                   [(zoom)]="miniMap.zoom" [maxZoom]="miniMap.maxZoom"
                   [minZoom]="miniMap.minZoom"
                   [keyboardShortcuts]="false"
                   (mapClick)="miniMap.click($event)"
                   [disableDefaultUI]="true">
            <exg-map-rectangle [north]="miniMap.rectangle.north" [south]="miniMap.rectangle.south"
                               [west]="miniMap.rectangle.west" [east]="miniMap.rectangle.east" strokeColor="red"
                               [strokeWeight]="1" fillColor="transparent" [clickable]="false"></exg-map-rectangle>
            <exg-map-marker [latitude]="miniMap.latitude" [longitude]="miniMap.longitude"
                            *ngIf="bigMap.zoom-miniMap.zoom > 7">
            </exg-map-marker>

          </exg-map>
        </div>
        <exg-map [latitude]="bigMap.latitude" [longitude]="bigMap.longitude" [(zoom)]="bigMap.zoom"
                 [minZoom]="bigMap.minZoom"
                 (boundsChange)="bigMap.boundsChange($event)" (mapReady)="bigMap.ready($event);"
                 [exgMapDrawingManager]="drawing">
          <exg-map-drawing-manager #drawing="exgMapDrawingManager"
                                   [circleOptions]="{fillColor:'red'}"></exg-map-drawing-manager>
          <exg-map-type-control></exg-map-type-control>
        <exg-map-marker  *ngFor="let marker of this.summaryData?.DL; let i = index" [latitude]="marker.adrLat"
                          [longitude]="marker.adrLng" [iconUrl]="markerInfo[i].marker"
                          [visible]="markerInfo[i].visible"
                          [label]="{text: marker.oeName.substring(0,1), fontSize:'10px'}">
            <exg-map-info-window #iw [togglemode]="true" [(isOpen)]="markerInfo[i].isOpen">
              <div>
                <strong>{{marker.oeName}}{{(marker?.oeEName?.length > 0) ? ', ' + marker.oeEName : ''}}</strong>
                <div class="typo-small">{{marker.adrStr}} {{marker.adrHNum}}</div>
                <div class="typo-small">{{marker.adrPlz}} {{marker.adrOrt}}</div>

                <div class="typo-small" style="font-size:x-small">{{marker.adrBez}}</div>
                <div class="typo-small" style="font-size:x-small" *ngFor="let o of markerInfo[i].messages">{{o}}</div>
                <div>&nbsp;</div>
                <div class="grid-1-auto">
                  <div>
                    <a href="javascript:void(0)" *ngIf="config.summaryData.selectedObjects.length > 0"
                       (click)="assign(marker);iw.close();">Zuweisen</a>
                  </div>
                  <div>
                    <span class="typo-small" style="font-size: xx-small;padding-left:0.5rem"
                          *ngFor="let elem of marker.origins">{{elem.result.distance}} ({{elem.result.duration}})
                    </span>
                  </div>
                </div>
              </div>
            </exg-map-info-window>
          </exg-map-marker>
          <exg-map-marker *ngFor="let marker of config.summaryData.selectedObjects" [latitude]="marker.adrLat"
                          [longitude]="marker.adrLng" [iconUrl]="markerIcon.SO" [markerClickable]="false"
                          [zIndex]="15">
            <exg-map-info-window>
              <strong>{{marker.auNr}}</strong>
              <div class="typo-small">{{marker.adrStr}} {{marker.adrHNum}}</div>
              <div class="typo-small">{{marker.adrPlz}} {{marker.adrOrt}}</div>
              <div class="typo-small">{{marker.adrZusatz}}</div>
            </exg-map-info-window>
          </exg-map-marker>
          <exg-map-heatmap-layer [opacity]="0.33" *ngIf="heatMapData.length > 0" [data]="heatMapData" [radius]="15"
                                 [maxIntensity]="20" [dissipating]="true"></exg-map-heatmap-layer>
        </exg-map>
      </div>
    </div>

  </div>
  <div></div>
</div>
